import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { AnnouncementItem } from '@/mocks/home';

interface AnnouncementListProps {
  announcements: AnnouncementItem[];
}

export default function AnnouncementList({ announcements }: AnnouncementListProps) {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (announcements.length <= 1) return;

    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % announcements.length);
    }, 2500);

    return () => clearInterval(timer);
  }, [announcements.length]);

  return (
    <div className="mx-3 mt-3 bg-white rounded-2xl p-3.5">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-1.5">
          <i className="ri-notification-3-line text-primary-500 text-lg" />
          <span className="text-foreground-900 font-semibold text-sm">平台公告</span>
        </div>
        <button
          onClick={() => navigate('/announcements')}
          className="flex items-center gap-0.5 text-foreground-400 text-xs cursor-pointer"
        >
          全部
          <i className="ri-arrow-right-s-line text-sm" />
        </button>
      </div>

      <div className="overflow-hidden" style={{ height: 24 }}>
        <div
          className="transition-transform duration-500 ease-in-out"
          style={{ transform: `translateY(-${currentIndex * 24}px)` }}
        >
          {announcements.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-2.5 cursor-pointer"
              style={{ height: 24 }}
              onClick={() => navigate('/announcements')}
            >
              <span className="flex-shrink-0 px-1.5 py-0.5 text-[10px] bg-primary-50 text-primary-500 rounded border border-primary-100">
                {item.type}
              </span>
              <span className="flex-1 text-foreground-700 text-sm truncate">
                {item.title}
              </span>
              <span className="text-foreground-400 text-xs flex-shrink-0">
                {item.date}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}